import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import Layout from './views/layout/Layout';
import Game from './views/game/Game';
import Editor from './views/editor/Editor';
import Help from './views/help/Help';

function App() {
  const dispatch = useDispatch();
  // First we get the viewport height and we multiple it by 1% to get a value for a vh unit
  let vh = window.innerHeight * 0.01;
  // Then we set the value in the --vh custom property to the root of the document
  document.documentElement.style.setProperty('--vh', `${vh}px`);

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Layout />} >
          <Route index element={<Game />} />
          <Route path='game' element={<Game />} />
          <Route path='editor' element={<Editor />} />
          <Route path='help' element={<Help />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
